import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    ctaWrapper: {
        paddingTop: '24px',
        paddingBottom: '24px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        gap: '10px',
        display: 'inline-flex',
        '@media (max-width: 1200px)': {
            alignItems: 'flex-start',
        },
    },

    ctaButton: {
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingTop: '24px',
        paddingBottom: '24px',
        background: '#F4F0E7',
        borderRadius: '40px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        display: 'inline-flex',
        cursor: 'pointer',
        border: 'none',
        textDecoration: 'none',
        transition: 'background 0.3s ease',
        '&:hover': {
            background: '#e8e1d1',
        },
    },

    ctaButtonText: {
        color: '#222222',
        fontSize: '20px',
        fontFamily: 'Figtree',
        fontWeight: 700,
        lineHeight: '20px',
        wordWrap: 'break-word',
    },
});

export interface AlyzeHeroCTAProps {
    /** Button text */
    text: string;
    /** Optional click handler */
    onClick?: () => void;
    /** Optional href for link behavior */
    href?: string;
}

export const AlyzeHeroCTA: React.FC<AlyzeHeroCTAProps> = ({
    text,
    onClick,
    href,
}) => {
    const styles = useStyles();

    const content = (
        <div className={styles.ctaButton} onClick={onClick}>
            <div className={styles.ctaButtonText}>{text}</div>
        </div>
    );

    return (
        <div className={styles.ctaWrapper}>
            {href ? (
                <a href={href} style={{ textDecoration: 'none' }}>
                    {content}
                </a>
            ) : (
                content
            )}
        </div>
    );
};
